import React, { Component } from "react";
import "./styles.css";
import G from "../../../js/globals";
import E from "../../../js/events";
import A from "axios";   // Axios  - https://github.com/axios/axios
import InputText    from "../../widgets/input-text/view";
// import imgChar      from "./img/whistle_c.png";
import LocationItem from "./location-item";
import Button  from "./button";



class SectionLocation extends Component {

  // ===============================================================================================
  constructor(props) {
    super(props);

    this.filterLocationsList = this.filterLocationsList.bind(this);
    this.filterLocationsListByText = this.filterLocationsListByText.bind(this);
    this.handleSearchChange  = this.handleSearchChange.bind(this);
    this.handleLocationClick = this.handleLocationClick.bind(this);
    this.getLocation = this.getLocation.bind(this);
    this.showPosition = this.showPosition.bind(this);
    this.locationError = this.locationError.bind(this);
    this.getDistance = this.getDistance.bind(this);
    this.deg2rad = this.deg2rad.bind(this);
    this.handleClickButton    = this.handleClickButton.bind(this);
    this.setProductsWithStoreLevelPricing = this.setProductsWithStoreLevelPricing.bind(this);

    this.state = {
      filteredLocations: [],  // Empty filtered-locations list to begin with
      buttonText: "Find Restaturants",
      buttonTextDisabled: false,
      message: "Getting a list of nearby party locations - please wait...",
      geolocationActive: true,
      maxDistance: {"hosted": 50, "no-host": 50}, // maximum distance of the locations to show in km
      maxFilteredListItems: 20,
      availableLocationsCount: 0,
    };

    // Set the initial location filter
    setTimeout(() => {
      const searchInput = document.querySelector('.input-text__input--search');
        if (searchInput && searchInput.value.trim() !== '') {
          this.handleSearchChange(searchInput.value);
        } else {
          this.getLocation();
        }
      // this.filterLocationsList(this.props.query);
    }, 1);
  }




  // ===============================================================================================
  handleClickButton() {
    // console.log(`SIDEBAR:\n Clicked ${0} (${this.props.items[0].id})`);
    this.props.handleChange('eventType');
  }


  //convert deg to radians
  deg2rad(deg) {
    return deg * (Math.PI / 180);
  }

    //haversine formula to calculate distance of two different locations using longitude and latitude
  getDistance(lat1, lon1, lat2, lon2) {
      var R = 6371; // Radius of the earth in km
      var dLat = this.deg2rad(lat2 - lat1); // deg2rad below
      var dLon = this.deg2rad(lon2 - lon1);
      var a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(this.deg2rad(lat1)) *
          Math.cos(this.deg2rad(lat2)) *
          Math.sin(dLon / 2) *
          Math.sin(dLon / 2);
      var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      var d = R * c; // Distance in km
      return d.toFixed(1);
  }

  showPosition(position) {


    let locations = this.props.locations;

    // // Filter locations by event type
    // locations = locations.filter((item) => {
    //   if (this.props.eventType === "hosted") {
    //     if (item.event_type_hosted === 1) {
    //       return true;
    //     }
    //     return false;
    //   } else if (this.props.eventType === "no-host") {
    //     if (item.event_type_no_host === 1) {
    //       return true;
    //     }
    //     return false;
    //   }
    // });


    //let myPosition = position.coords;
    let myLat = position.coords.latitude;
    let myLong = position.coords.longitude;

     //new york long to avoid error
    let farFarAway = this.getDistance(myLat, myLong, 40.741895, -73.989308);
    // console.log("LOCATION:\n");
    // console.log(locations);

    for ( let i = 0; i < this.props.locations.length; i++ ) {
      if ( this.props.locations[i].lat_long != null ) {
        this.props.locations[i].distance_to_visitor = this.getDistance(myLat, myLong, this.props.locations[i].lat_long.lat, this.props.locations[i].lat_long.lng);
      }
      else {
        this.props.locations[i].distance_to_visitor = farFarAway;
      }   
    }

    // console.log(this.props.locations);
    let FilteredDistanceArray = locations.filter((item) => {
      if (item.distance_to_visitor <= this.state.maxDistance[this.props.eventType]) {
        return true;
      }
      return false;
    });

    let FinalSorteddistanceArray = FilteredDistanceArray.sort(function(a, b) {
      return a.distance_to_visitor - b.distance_to_visitor;
    });


    let max  = FinalSorteddistanceArray.length;
    let list = FinalSorteddistanceArray.slice(0, Math.min(this.state.maxFilteredListItems, max));

    let availableLocationsCount = 0;
    for (let i = 0; i < FinalSorteddistanceArray.length; i++) {
      if (this.props.eventType === 'hosted' && FinalSorteddistanceArray[i].event_type_hosted === 1) {
        availableLocationsCount++;
      } else if (this.props.eventType === 'no-host' && FinalSorteddistanceArray[i].event_type_no_host === 1) {
        availableLocationsCount++;
      }
    }
    this.setState({ availableLocationsCount: availableLocationsCount });

    // console.log(list);
    // Create new list of locations
    this.setState({ geolocationActive: true });
    this.setState({ filteredLocations: list });
    this.setState({ buttonText: "Showing Restaurants Near by" });
    this.setState({ buttonTextDisabled: true });

    if (max === 0) {
      this.setState({ message: "There are currently no available Restaurants near your location. Come back again soon, to see more Restaurants." });
    }
    else {
      this.setState({ message: "Nearby party locations" });
    }
    


  }

  locationError(err) {
    console.warn(`ERROR(${err.code}): ${err.message}`);
    this.setState({ geolocationActive: false });
    this.filterLocationsList(this.props.query);
  }

  //Activate Geolocation
  getLocation() {

    const locationOptions = {
      enableHighAccuracy: true,
      timeout: 5000,
      maximumAge: 0,
    };
    this.setState({ buttonText: "Finding Restaurants" });
    if (navigator.geolocation && this.state.geolocationActive !== false) {
      navigator.geolocation.getCurrentPosition(this.showPosition, this.locationError, locationOptions);
    } else { 
      // locationResult.innerHTML = "Geolocation is not supported by this browser.";
      this.setState({ geolocationActive: false });
      this.filterLocationsList(this.props.query);
    }

    

  }
  
  
  // ===============================================================================================
  filterLocationsList(query) {
    // console.log(`LOCATION:\n Updating locations list`, query);

    query = query.toLowerCase().trim();

    let search_coordinates = "";
    let position = {};
    let queryIsInteger = false;
    let minQueryLength = 3;

    queryIsInteger = /^\d+$/.test(query);

    // let postCode = parseInt(query);
    if(query !== "" && queryIsInteger) {
      if (query.length !== 4) {
        this.setState({ message: "Please enter a valid Australian postcode with 4 digits" });
        this.setState({ filteredLocations: [] });
        return;
      }
      this.setState({ message: "Getting a list of nearby party locations - please wait..." });
      // Make a request for a user with a given ID
      A.get(G.data.getPostcodeLookup(query))
      // A.get("http://localhost:3000/mcd_postcode_lookup.json?location=" + query)
      .then((response) => {
        // handle success
        // console.log(response);
        if(response.data.suggestions.length) {
          
          search_coordinates = response.data.suggestions[0].data.split(',');
          position = { 
            coords: { 
              longitude: search_coordinates[0], 
              latitude: search_coordinates[1] 
            }
          };
          this.showPosition(position);
        }
        else {
          // this.filterLocationsListByText(query);
          this.setState({ message: "We can't find this postcode." });
          this.setState({ filteredLocations: [] });
          return;
        }
      })
      .catch((error) => {
        // handle error
        console.warn(error);
        // this.locationError(error);
        // this.filterLocationsListByText(query);
        this.setState({ message: "We can't find this postcode." });
      })
    } else if (query === "" && this.state.geolocationActive !== false){
      this.setState({ message: "Getting a list of nearby party locations - please wait..." });
      this.setState({ filteredLocations: [] });
      // Set the initial location filter
      setTimeout(() => {
        this.getLocation();
      }, 1);
    } else if (query !== "" && query.length >= minQueryLength){
      this.filterLocationsListByText(query);
    } else {
      this.setState({ message: "Please enter at least " + minQueryLength + " characters" });
    }
  }

  // ===============================================================================================
  filterLocationsListByText(query) {
    // console.log(`LOCATION:\n Updating locations list`, query);


    let locations = this.props.locations;

    // // Filter locations by event type
    // locations = locations.filter((item) => {
    //   if (this.props.eventType === "hosted") {
    //     if (item.event_type_hosted === 1) {
    //       return true;
    //     }
    //     return false;
    //   } else if (this.props.eventType === "no-host") {
    //     if (item.event_type_no_host === 1) {
    //       return true;
    //     }
    //     return false;
    //   }
    // });


    query = query.toLowerCase().trim();

    let newFilteredList = locations.filter((item) => {
      if ( query === "" || (item.name).toLowerCase().includes(query) || (item.address).toLowerCase().includes(query) || item.store_postcode.toString().toLowerCase().includes(query) )  {
        return true;
      }
      return false;
    });

    let max  = newFilteredList.length;
    let list = newFilteredList.slice(0, Math.min(this.state.maxFilteredListItems, max));

    let availableLocationsCount = 0;
    for (let i = 0; i < newFilteredList.length; i++) {
      if (this.props.eventType === 'hosted' && newFilteredList[i].event_type_hosted === 1) {
        availableLocationsCount++;
      } else if (this.props.eventType === 'no-host' && newFilteredList[i].event_type_no_host === 1) {
        availableLocationsCount++;
      }
    }
    this.setState({ availableLocationsCount: availableLocationsCount });

    // Create new list of locations
    this.setState({ filteredLocations: list });

    if (query === "") {
      if (this.state.geolocationActive) {
        if (max === 0) {
          this.setState({ message: "There are currently no available Restaurants near your location. Come back again soon, to see more Restaurants." });
        }
        else {
          this.setState({ message: "Nearby party locations" });
        }
      } else {
        this.setState({ message: "Geolocation is not working, please search for a postcode or suburb." });
        this.setState({ filteredLocations: [] }); // Don't show any restaurants if geolocation is deactivated and the user didn't search
      }
    } else if (max === 0) {
      this.setState({ message: "Sorry, we can't find anything matching your search" });
    } else {
      this.setState({ message: "Party locations matching your search" });
    }
    
  }



  // ===============================================================================================
  handleSearchChange(value) {
    // console.log(`LOCATION:\n Search term change: ${value}`);
    this.filterLocationsList(value);
    this.props.handleAppEvent(E.events.LOCATION_MOD_QUERY, value);
  }



  // ===============================================================================================
  handleLocationClick(id) {

    if (this.props.selLocation && this.props.selLocation.id === id) {
      this.props.handleAppEvent(E.events.LOCATION_MOD_DEST, null);
    }
    else {
      let list = this.state.filteredLocations;
      for (let i = 0; i < list.length; i++) {
        if (list[i].id === id) {
          this.setProductsWithStoreLevelPricing(list[i]);
          this.props.handleAppEvent(E.events.LOCATION_MOD_DEST, list[i]);
          break;
        }
      }
    }
  }



    // ===============================================================================================
    setProductsWithStoreLevelPricing(selLocation){

      if (!selLocation) { 
        return; 
      }

      // Create a deep copy of products to not alter the default pricing
      let products = JSON.parse(JSON.stringify(this.props.products));
      for (let key in products) {
        if (products[key].allow_store_level_pricing === 1 && selLocation && selLocation.store_level_pricing && selLocation.store_level_pricing[key] && selLocation.store_level_pricing[key].price && parseInt(selLocation.store_level_pricing[key].price) > 0) {
          products[key].price = selLocation.store_level_pricing[key].price;
          // console.log("EVENTS: ", selLocation.store_level_pricing[key]);
        }
      }
      selLocation.products = products;
      // console.log("----PRODUCTS: ", products);
      // console.log("----SELECTED LOCATION: ", selLocation);
      return selLocation;
    }



  // ===============================================================================================
  render() {

    // ---------------------------------------------------------------------------------------------
    let curLocId = (this.props.selLocation) ? this.props.selLocation.id : null;
    let locationEventTypeNoticeBody = {
      "hosted": "Try a different postcode, or change your booking type, to see nearby event space locations.",
      "no-host": "Try a different postcode, or change your booking type, to see nearby party locations."
    };


    // ---------------------------------------------------------------------------------------------
    return (


      <div className="cont-section cont-section--offset-header cont-section--offset-footer cont-section--offset-sidebar cont-section--location">

        <div className="cont-wrapper">

          {/* <!-- Import Html to find Location --> */}

         <div className="findme-container"> 

              <div className="findme-text"> 
              Choose your location<br />
              </div>

              {/* <div>
                <button id="buttonLocation" className="findme-button"  onClick={this.getLocation}> {this.state.buttonText} </button>
              </div> */}

          </div>

          <div className="cont-location cont-location--search">

            <InputText
              type="search"
              className="location-search"
              placeholder="Enter postcode or suburb"
              value={this.props.query}
              handleChange={this.handleSearchChange}
            />

            <div className="location-message">
              {this.state.message}
            </div>

          </div>



          <div className="cont-location cont-location--locations">
            <>
              <div className="locations-list">
                {
                  this.state.filteredLocations.map((item) => (
                    <LocationItem
                      eventType={this.props.eventType}
                      item={item}
                      key={item.id}
                      details={item}
                      selected={curLocId === item.id}
                      minCapacity={item.min_capacity}
                      maxCapacity={item.max_capacity}
                      numAttending={this.props.numAttending}
                      handleClick={this.handleLocationClick}
                    />
                  ))
                }
              </div>
              {this.state.availableLocationsCount <= 0 && (
                <div className="location-event-type-notice">
                  <h2>Location unavailable?</h2>
                  <p>{locationEventTypeNoticeBody[this.props.eventType]}</p>
                  <div className="submit-btn-container">
                    <Button
                      label="Change your booking type here"
                      className="change-event-type-btn"
                      canSubmit={true}
                      disabled={false}
                      handleClick={this.handleClickButton}
                    />
                  </div>
                </div>
              )}
            </>
          </div>




        </div>
      </div>
    );
  }

}



export default SectionLocation